/* Tillitsstripen (Fase B, T15/T17): skjul skillestrekene når raden bryter.

   Brytingen er innholdsstyrt, ikke breddestyrt — lengre etiketter fra
   seksjonsinnstillingene, eller tekstforstørring der brukeren øker
   skriftstørrelsen uten å endre vindusbredden (WCAG 1.4.4), kan bryte raden
   på en bred skjerm. En breddespørring alene gjetter derfor feil, og en
   strek blir hengende sist på en linje der den peker mot ingenting.

   CSS-en beholder mobilspørringen som fallback, så uten JS oppfører stripa
   seg som før. */
(function () {
  'use strict';

  /* Testen går på x, ikke på y. Elementene har ulik høyde — logoen er 12 px,
     tekstene ~15 px — og med align-items: center får de ulik offsetTop selv
     når de står på samme linje. En y-test meldte derfor «brutt» ved 1440 px
     og skjulte strekene på full bredde. Bryter raden, starter neste linje
     lenger til venstre enn elementet før: det er entydig. */
  function erBrutt(rad) {
    var el = rad.querySelectorAll('.nf-tillit-element');
    if (el.length < 2) return false;
    var forrige = -Infinity;
    for (var i = 0; i < el.length; i++) {
      var venstre = el[i].getBoundingClientRect().left;
      if (venstre < forrige - 0.5) return true;
      forrige = venstre;
    }
    return false;
  }

  function oppdater(rad) {
    /* Måles alltid uten klassen: strekene er 1 px + 11 px margin hver, og
       med klassen på ville de vært borte fra målingen — da ville raden se
       ut til å få plass, klassen fjernes, strekene kommer tilbake, og den
       bryter igjen. Klassisk vippetilstand. */
    var hadde = rad.classList.contains('er-brutt');
    if (hadde) rad.classList.remove('er-brutt');
    var brutt = erBrutt(rad);
    if (brutt) rad.classList.add('er-brutt');
  }

  function init(rad) {
    if (rad.dataset.nfTillit) return;
    rad.dataset.nfTillit = '1';
    oppdater(rad);

    /* Begge deler, ikke enten/eller. resize dekker den vanlige veien —
       vindusbredde — og er en ren hendelse. ResizeObserver dekker det
       resize ikke ser: at teksten endres i theme-editoren, eller at
       brukeren skrur opp skriftstørrelsen. RO-varsler leveres som del av
       nettleserens tegnesyklus og uteblir i strupte faner, så den kan ikke
       stå alene. */
    window.addEventListener('resize', function () { oppdater(rad); });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { oppdater(rad); });
      ro.observe(rad);
    }

    /* Webfontene endrer tekstbredden når de bytter inn. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { oppdater(rad); });
    }
  }

  function boot(rot) {
    var rader = (rot || document).querySelectorAll('.nf-tillit-rad');
    Array.prototype.forEach.call(rader, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
